export default "__VITE_ASSET__DwGFJu56__"